<template>
  <div>
    <div
      v-show="content"
      :class="['sm-fenji', showAllContent ? 'show' : '']"
    >
      <div class="sm-tit">
        {{ plotTitle }}
      </div>
      <div
        v-show="content"
        class="sm-con"
        v-html="content"
      />
      <div
        v-if="content.length > 160"
        class="sm-plot-show"
        @click="showContent"
      >
        <span>阅读全文</span>
      </div>
      <div
        v-if="showPlayBtn"
        class="sm-plot-play"
        @click="play"
      >
        <span>播放本集</span>
      </div>
    </div>
    <div
      v-if="isTeleplay && content"
      class="sm-plot-set"
    >
      <p
        :class="[current_ep <= 1 ? 'dis' : '']"
        @click="prevEpClick"
      >
        上一集
      </p>
      <p @click="changeComponents">
        选集
      </p>
      <p
        :class="[current_ep >= updating_ep ? 'dis' : '']"
        @click="nextEpClick"
      >
        下一集
      </p>
    </div>
    <component
      :is="current"
      :show-ep-comp="showEpComp"
      @hideMask="hideEpComp"
    />
  </div>
</template>

<script>
import URL from '@tencent/search-url';
import { mapState } from 'vuex';

export default {
  components: {
    Episode(resolve) {
      require(['./Episode.vue'], resolve);
    },
  },
  data() {
    const ep = parseInt(this.$route.query.ep, 10) || 1;
    return {
      ep,
      current: '',
      showEpComp: false,
      showAllContent: false,
    };
  },
  computed: {
    ...mapState('summary', ['itemData']),
    item() {
      return this.itemData;
    },
    dockey() {
      return this.itemData.dockey;
    },
    current_ep() {
      return this.itemData.plot_info.ep || 1;
    },
    updating_ep() {
      return this.itemData.plot_info.plotUpdatingEp || 0;
    },
    isTeleplay() {
      const { dockey = '' } = this.itemData;
      if (dockey.indexOf('teleplay') > -1) {
        return true;
      }
      return false;
    },
    plotTitle() {
      const item = this.itemData;
      if (item && item.plot_info) {
        const { ep, title_list: titleList } = item.plot_info;
        if (titleList) {
          return titleList[ep];
        }
      }
      return '';
    },
    content() {
      let content = '';
      const item = this.itemData;
      if (item && item.plot_info) {
        if (item.plot_info.content) {
          content = item.plot_info.content;
        }
      }
      return content;
    },
    showPlayBtn() {
      const item = this.itemData;
      if (item && item.plot_info) {
        const { content } = item.plot_info;
        const { play_url: playUrl } = item.plot_info;
        if (playUrl && ((content && content.length <= 160) || this.showAllContent)) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    play() {
      const { item } = this;
      if (item && item.plot_info) {
        const { play_url: playUrl } = item.plot_info;
        if (playUrl && typeof playUrl !== 'undefined') {
          location.href = playUrl;
        }
      }
    },
    showContent() {
      this.showAllContent = 'true';
    },
    prevEpClick() {
      if (this.current_ep <= 1) return false;
      const ep = parseInt(this.ep, 10);
      const { query } = this.$route;
      if (!ep || isNaN(ep) || ep < 1) query.ep = 1;
      query.ep = ep - 1;
      window.location.href = `/summary/plot?${URL.stringify(query)}`;
    },
    nextEpClick() {
      if (this.current_ep >= this.updating_ep) return false;
      const { ep } = this;
      const { query } = this.$route;
      if (!ep || isNaN(ep) || ep < 1) query.ep = 1;
      query.ep = ep + 1;
      window.location.href = `/summary/plot?${URL.stringify(query)}`;
    },
    changeComponents() {
      this.current = 'Episode';
      this.showEpComp = true;
      this.stopBodyScroll(true);
    },
    hideEpComp() {
      this.showEpComp = false;
    },
    stopBodyScroll(isFixed) {
      const bodyEl = document.body;
      if (isFixed) {
        window.theTop = window.scrollY;
        bodyEl.style.position = 'fixed';
        bodyEl.style.width = '100%';
        bodyEl.style.top = `${-window.theTop}px`;
      } else {
        bodyEl.style.position = '';
        bodyEl.style.top = '';
        // 回到原先的top
        window.scrollTo(0, window.theTop || 0);
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.sm-fenji {
  position: relative;
  padding: 0 15px;
  overflow: hidden;
  font-size: 17px;
  color: #222;
}
.sm-fenji .sm-tit {
  color: rgba(34, 34, 34, 1);
  line-height: 21px;
  margin: 16px 0px 10px 0;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.sm-fenji.show .sm-con {
  max-height: unset;
}

.sm-fenji.show .sm-plot-show {
  display: none;
}

.sm-con {
  color: rgba(34, 34, 34, 1);
  line-height: 29px;
  max-height: 232px;
  overflow: hidden;
}
.sm-plot-play,
.sm-plot-show {
  height: 40px;
  line-height: 40px;
  background: rgba(245, 245, 245, 1);
  border-radius: 3px;
  margin-top: 14px;
  text-align: center;
}

.sm-plot-play span {
  font-size: 15px;
  color: rgba(34, 34, 34, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  &:before {
    content: '';
    margin-right: 4px;
    @include sprite-item('detail/play_b');
  }
}

.sm-plot-show span {
  font-size: 13px;
  color: rgba(34, 34, 34, 1);
  &:after {
    content: '';
    display: inline-block;
    @include arr(6px, 135deg, #222);
    margin-left: 6px;
    vertical-align: 3px;
  }
}

.sm-plot-set {
  margin: 17px 14px 0px;
  display: flex;
  overflow: hidden;
}

.sm-plot-set p {
  position: relative;
  text-align: center;
  line-height: 21px;
  height: 21px;
  font-size: 15px;
  color: #222222;
  flex: 1;
}

.sm-plot-set p.dis {
  color: #999999;
}

.sm-plot-set p:nth-child(2) {
  flex: unset;
  position: relative;
  width: 30%;
}

.sm-plot-set p:nth-child(2):before,
.sm-plot-set p:nth-child(2):after {
  content: '';
  position: absolute;
  height: 15px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  background: rgba(245, 245, 245, 1);
  width: 1px;
}

.sm-plot-set p:nth-child(2):before {
  left: 0;
}

.sm-plot-set p:nth-child(2):after {
  right: 0;
}
</style>
